import React from 'react';
import { useTranslation } from 'react-i18next';

const PageSizeSelector = ({pageSize, setPageSize, setpageNumber}) => {
    const { t } = useTranslation();
   
    const handlePageSizeChange = (e) => {
        const newPageSize = parseInt(e.target.value);
        setPageSize(newPageSize);
        setpageNumber(0);
    };

    return (
        <div className="page-size-selector">
            <span className="page-size-label">{t('users.table.pageSize.label')}</span>
            <select
                className="page-size-select"
                value={pageSize}
                onChange={handlePageSizeChange}
            >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={30}>30</option>
            </select>
            <span className="page-size-suffix">{t('users.table.pageSize.entries')}</span>
        </div>
    );
};

export default PageSizeSelector;